import { useMemo } from 'react';
import { useQuery } from '@grandvisionhq/graphql';
import { toAppointment } from '../mappers/appointment.js';
import { GET_APPOINTMENT_BY_ID } from '../operations/queries/get-appointment-by-id.js';

const useGetAppointmentById = (id)=>{
    const { data , loading , error  } = useQuery(GET_APPOINTMENT_BY_ID, {
        variables: {
            id
        }
    });
    return useMemo(()=>{
        return {
            data: toAppointment(data === null || data === void 0 ? void 0 : data.appointment),
            loading,
            error
        };
    }, [
        data,
        error,
        loading
    ]);
};

export { useGetAppointmentById };
//# sourceMappingURL=useGetAppointmentById.js.map
